export default "__VITE_ASSET__B5xpRdmU__"